var sound_control_default = {
  "root": "B31kb",
  "sliderContainer": "o-BMu"
};
export {
  sound_control_default as default
};
//# sourceMappingURL=sound-control-scss.js.map
